import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { writeWithAiApi, writeWithAiDescriptionApi } from "../../API/API";

function* writeWithAiSaga(action) {
  const { onSuccess, onError, ...body } = action.payload;
  try {
    const response = yield call(() => writeWithAiDescriptionApi(body));
    yield put({ type: types.WRITE_WITH_AI_SUCCESS, payload: response.data });
    if (onSuccess) yield call(onSuccess, response.data);
  } catch (error) {
    yield put({ type: types.WRITE_WITH_AI_FAILURE, payload: error });
    if (onError) yield call(onError, error);
  }
}

export function* watchWriteWithAiSaga() {
  yield takeEvery(types.WRITE_WITH_AI_INIT, writeWithAiSaga);
}

function* createFirstJobSaga(action) {
  const { onSuccess, onError, ...body } = action.payload;
  try {
    const response = yield call(() => writeWithAiApi(body));
    yield put({ type: types.CREATE_FIRST_JOB_SUCCESS, payload: response.data });
    if (onSuccess) yield call(onSuccess, response.data);
  } catch (error) {
    yield put({ type: types.CREATE_FIRST_JOB_FAILURE, payload: error });
    if (onError) yield call(onError, error);
  }
}

export function* watchCreateFirstJobSaga() {
  yield takeEvery(types.CREATE_FIRST_JOB_INIT, createFirstJobSaga);
}
